interface ObjType {
  [key: string]: any,
}

type Merge<A, B> = {
  [K in keyof A]: K extends keyof B ? B[K] : A[K]
} & B;

const deepObjMerge = <T extends ObjType, U extends ObjType>(defaults: T, newValues: U): Merge<T, U>  => (
  Object.keys(newValues)
    .reduce((combiner: Merge<T, U>, key: string): Merge<T, U> => {
      const newObjectValue = newValues[key];
      const defaultValue = defaults[key];
  
      const value = typeof newObjectValue === 'object' && typeof defaultValue === 'object'
        ? deepObjMerge(defaultValue, newObjectValue)
        : newObjectValue;
  
      return {
        ...combiner,
        [key]: value,
      };
    }, {...defaults} as Merge<T, U>)
);


export default deepObjMerge;